import {
  Component,
  Input,
  OnInit, ViewChild,
} from '@angular/core';

import '@web-comp/core';
import '@web-comp/json-viewer';

@Component({
  selector: 'sb-json-viewer',
  templateUrl: './json-viewer.component.html',
  styleUrls: ['./json-viewer.component.scss']
})
export class JsonViewerComponent implements OnInit {
  @ViewChild('jsonView', {static: false}) jsonView;

  @Input()
  get json(): any {
    return this._json;
  }
  set json(json: any) {
    this._json = json;
    this.update();
  }
  _json: any;

  constructor() { }

  ngOnInit(): void {
  }

  private update() {
    this.jsonView && this.jsonView.nativeElement.setConfig({data: this._json});
  }

}
